<template>
  <div class="bill_management">
    <div class="bill_top">
      <el-form :inline="true" :model="formInline" class="form">
        <el-form-item label="门店列表">
          <el-select v-model="formInline.store_id" filterable placeholder="门店列表" clearable >
            <el-option
              v-for="item in roomList"
              :key="item.id"
              :label="item.room_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单来源">
          <el-select v-model="formInline.nickname" filterable placeholder="请选择订单来源" clearable >
            <el-option
              v-for="item in optionsMobile"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="formInline.nickname" filterable placeholder="请选择支付方式" clearable >
            <el-option
              v-for="item in optionsMobile"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <div style="display: flex;">
            <div class="time_change" :class="formInline.time == 1 ? 'time_select': ''" @click="changTime(1)">今天</div>
            <div class="time_change" :class="formInline.time == 2 ? 'time_select': ''" @click="changTime(2)">本周</div>
            <div class="time_change" :class="formInline.time == 3 ? 'time_select': ''" @click="changTime(3)">本月</div>
            <div class="time_change" :class="formInline.time == 4 ? 'time_select': ''" @click="changTime(4)">本年</div>
          </div>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="formInline.value1"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" class="form_btn">
            <img src="../assets/static/query.png" class="btn_img" />查询
          </el-button>
        </el-form-item>
      </el-form>
      <div class="bill_pay">
        <span>支付统计概况</span>
        <span style="font-size: 14px;color: #999999;padding-left: 12px;">查询日期：2023-03-24 17:01:02</span>
      </div>
      <div class="bill_statistics">
        <div
          class="statistics"
          style="background: linear-gradient( 285deg, #57FBCC 0%, #00D3FF 100%);"
        >
          <div>线下支付总金额</div>
          <div style="font-size: 24px;">2344</div>
        </div>
        <div
          class="statistics"
          style="background: linear-gradient( 285deg, #FF5600 0%, #FFB100 100%);"
        >
          <div>外卖订单总金额</div>
          <div style="font-size: 24px;">333</div>
        </div>
        <div
          class="statistics"
          style="background: linear-gradient( 285deg, #FF5600 0%, #FFB100 100%);"
        >
          <div>服务费总金额</div>
          <div style="font-size: 24px;">333</div>
        </div>
        <div class="statistics">
          <div style="color: #666666;">美团闪购</div>
          <div style="font-size: 24px;color: #333333;">333</div>
        </div>
        <div class="statistics">
          <div style="color: #666666;">饿了吗零售</div>
          <div style="font-size: 24px;color: #333333;">333</div>
        </div>
        <div class="statistics">
          <div style="color: #666666;">京东到家</div>
          <div style="font-size: 24px;color: #333333;">333</div>
        </div>
        <div class="statistics">
          <div style="color: #666666;">淘宝小时达</div>
          <div style="font-size: 24px;color: #333333;">333</div>
        </div>
      </div>
    </div>
    <div class="bill_bottom" ref="tableRef">
      <div class="bill_bottom_pay">
        <span>收入明细</span>
        <span style="font-size: 14px;color: #999999;padding-left: 12px;">查询日期：2023-03-24 17:01:02</span>
      </div>
      <div class="table_data">
        <el-table :data="tableData" border :height="tableHeight" :row-style="tableRowStyle">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" prop="date" label="id" width="150"></el-table-column>
          <el-table-column align="center" prop="date" label="门店名称" width="160"></el-table-column>
          <el-table-column align="center" prop="name" label="用户昵称"></el-table-column>
          <el-table-column align="center" prop="province" label="用户手机号"></el-table-column>
          <el-table-column align="center" prop="city" label="订单来源" width="120"></el-table-column>
          <el-table-column align="center" prop="address" label="用户实付"></el-table-column>
          <el-table-column align="center" prop="zip" label="商家实收" ></el-table-column>
          <el-table-column align="center" prop="zip" label="服务费"></el-table-column>
          <el-table-column align="center" prop="zip" label="操作时间"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="260">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" class="right_btn">订单详情</el-button>
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                class="right_btn right_btn_color"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { roomList } from "@/utils/api/index";

export default {
  name: "billManagement",
  data() {
    return {
      formInline: {
        store_id:'',
        user: "",
        nickname: "",
        time: 1,
        value1: ""
      },
      optionsMobile: [],
      currentPage: 1,
      tableHeight: 200,
      roomList: [],
      total: 0,
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1517 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1519 弄",
          zip: 200333
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1516 弄",
          zip: 200333
        }
      ]
    };
  },
  created() {
    this.getRoomList()
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      const div = this.$refs.tableRef;
      this.tableHeight = div.offsetHeight - 236;
      this.$emit('getToken')
    });
  },
  methods: {
    changTime(value) {
      this.formInline.time = value
    },
    getList(type) {
      if(type == 1) {
        this.total = 0
        this.tableData = []
      }
    },
    getRoomList() {
      roomList({
        name: this.nameTop
      }).then(res => {
        this.roomList = res.data;
      });
    },
    onSubmit() {},
    handleSizeChange(e) {
      console.log(e, "size");
    },
    handleCurrentChange(e) {
      console.log(e, "current");
    },
    tableRowStyle({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return {
          background: "#16264a"
        };
      } else {
        return {
          background: "#0d193c"
        };
      }
    }
  }
};
</script>
<style scoped lang="scss">
.bill_management {
  height: calc(100% - 54px);
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  .bill_top {
    width: 100%;
    background: #213456;
    padding: 30px 0px;
    .form {
      margin-left: 30px;
      color: #d4e6ff !important;
      :deep(.el-picker-panel) {
        background: linear-gradient( 178deg, #0E3671 0%, #174486 100%);
      }
      .time_change {
        width: 61px;
        height: 36px;
        background: #051238;
        border: 1px solid #2f416b;
        font-size: 14px;
        color: #cccccc;
        text-align: center;
        line-height: 36px;
      }
      .time_select {
        background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        border-radius: 2px 0px 0px 2px;
        border: 1px solid #5fbcf5;
        font-size: 18px;
        color: #ffffff;
      }
      :deep(.el-form-item__label) {
        font-size: 14px;
        color: #d4e6ff;
      }
      :deep(.el-input__inner) {
        height: 36px;
        background: #051238;
        border-radius: 2px;
        color: #ffffff;
      }
      :deep(.el-range-editor .el-range-input) {
        background: #051238;
      }
      .form_btn {
        width: 90px;
        height: 36px;
        background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
        border-radius: 4px;
        border: 1px solid #5fbcf5;
        .btn_img {
          width: 16px;
          vertical-align: middle;
          margin-right: 6px;
        }
      }
      
    }
    .bill_pay {
      font-size: 18px;
      color: #ffffff;
      padding-bottom: 13px;
      margin: 30px;
      margin-top: 30px;
      border-bottom: 1px solid #051238;
    }
    .bill_statistics {
      display: flex;
      padding-left: 30px;
      .statistics {
        width: 212px;
        height: 90px;
        margin-right: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        box-sizing: border-box;
        border-radius: 4px;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        padding-left: 20px;
        background: #fafcff;
      }
    }
  }
  .bill_bottom {
    flex-grow: 1;
    background: #213456;
    padding: 30px 0px;
    margin-top: 10px;
    .bill_bottom_pay {
      font-size: 18px;
      color: #ffffff;
      padding-bottom: 13px;
      margin: 30px;
      margin-top: 30px;
      border-bottom: 1px solid #051238;
    }
    .el-pagination {
      text-align: center;
      margin-top: 24px;
      margin-bottom: 14px;
    }
    .pagination {
      :deep(.el-pagination__total) {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.88);
        margin-top: 4px;
      }
      :deep(.el-input__inner) {
        background: #051238;
        border-radius: 6px;
        font-size: 16px;
        color: #cccccc;
        border: 0;
        margin-top: 4px;
      }
      :deep(.btn-prev) {
        width: 36px;
        height: 36px;
        background: #29456e;
        border-radius: 7px;
      }
      :deep(.el-pager li) {
        width: 36px;
        height: 36px;
        border-radius: 7px;
        background: #29456E;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #ffffff;
        line-height: 36px;
        font-size: 18px;
        border-radius: 7px;
        margin: 0 5px;
      }
      :deep(.btn-next) {
        width: 36px;
        height: 36px;
        background: #29456e;
        border-radius: 7px;
      }
      :deep(.el-pagination__jump) {
        font-size: 18px;
        margin-top: 4px;
      }
      :deep(.el-pager li.active) {
        background: linear-gradient(
          180deg,
          #0e3671 0%,
          #2571b5 100%
        ) !important;
        border: 1px solid #5fbcf5;
      }
    }
    :deep(thead .el-table__cell) {
      background-color: #16264a;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
    }
    :deep(.el-table__fixed-right-patch) {
      background: #213456 !important;
    }
    .table_data {
      padding: 0 30px;
      box-sizing: border-box;
      :deep(.el-table__body tr.hover-row > td) {
        background-color: transparent !important;
      }
      .el-table {
        background-color: #0d193c;
        border: 1px solid #2f416b;
      }
      .el-table--border::after,
      .el-table--group::after,
      .el-table::before {
        background: transparent;
      }

      .el-table__fixed-right::before,
      .el-table__fixed::before {
        background: transparent !important;
      }
    }
    .right_btn {
      width: 90px;
      height: 36px;
      background: linear-gradient(180deg, #0e3671 0%, #2571b5 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      padding-bottom: 28px;
    }
    .right_btn_color {
      background: linear-gradient(180deg, #a9801d 0%, #b56625 100%);
      border-radius: 4px;
      border: 1px solid #fcd486;
    }
    .right_btn_color_big {
      background: linear-gradient(180deg, #0e6871 0%, #25b587 100%);
      border-radius: 4px;
      border: 1px solid #5fbcf5;
    }
  }
}
</style>
